import { updateArrayObj } from 'helpers/array';
import { gmailAccountsVar } from 'query/gmail';
import { useUpdate } from './root';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { unwatchGmailAccounts, watchGmailAccounts } from 'services/gmail';

export const useUpdateGmailAccount = id =>
  useUpdate('mail/gmail/:id', id, {
    onSuccess: data =>
      gmailAccountsVar(
        updateArrayObj(gmailAccountsVar(), data, { moveItemToTop: true }),
      ),
  });

export const useUnblockGmailAccount = id =>
  useUpdate('mail/gmail/:id/unblock', id, {
    onSuccess: data =>
      gmailAccountsVar(
        updateArrayObj(gmailAccountsVar(), data, { moveItemToTop: true }),
      ),
  });

export const useWatchGmailAccounts = () => {
  const queryClient = useQueryClient();
  return useMutation(watchGmailAccounts, {
    onSuccess: async updated => {
      queryClient.setQueryData(
        ['get-gmail-account-watch-status'],
        () => updated,
      );
    },
  });
};

export const useUnWatchGmailAccounts = () => {
  const queryClient = useQueryClient();
  return useMutation(unwatchGmailAccounts, {
    onSuccess: async updated => {
      queryClient.setQueryData(
        ['get-gmail-account-watch-status'],
        () => updated,
      );
    },
  });
};
